import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';
import { ClickToCopyComponent } from './click-to-copy.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        SharedModule,
        MatIconModule,
    ],
    exports: [ClickToCopyComponent],
    declarations: [ClickToCopyComponent],
})
export class ClickToCopyModule
{
}
